import React from "react";
import PropTypes from "prop-types";

const TabsContext = React.createContext({
  activeTab: 0,
  setActiveTab: () => {},
  focusedTab: null,
  setFocusedTab: () => {},
});

TabsContext.propTypes = {
  activeTab: PropTypes.number, // The index of the currently active tab
  setActiveTab: PropTypes.func.isRequired,
  focusedTab: PropTypes.number, // The index of the currently focused tab
  setFocusedTab: PropTypes.func.isRequired,
};

export default TabsContext;
